import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container } from "react-bootstrap";

import "./styles.scss";
import Banner from "./Banner";
import BannerController from "./BannerController";

class BannersContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      banners: [],
    };
  }

  componentDidMount = () =>
    BannerController.addChangeListener(this.handleStateChange);

  componentWillUnmount = () =>
    BannerController.removeChangeListener(this.handleStateChange);

  handleStateChange = banners => this.setState({ banners });

  handleClose = bannerId => BannerController.removeById(bannerId);

  render() {
    const { banners } = this.state;
    return (
      <Container
        fluid
        className={classNames("banner-container px-0", this.props.className)}
      >
        <Container
          id="bannerAbsoluteContainer"
          fluid
          className="banner-absolute-container px-0"
        >
          {[...banners].reverse().map(banner => (
            <Banner
              key={banner.id}
              id={banner.id}
              showIcon={banner.showIcon}
              closable={banner.closable}
              type={banner.type}
              message={banner.message}
              actions={banner.actions || []}
              onClose={this.handleClose}
            />
          ))}
        </Container>
      </Container>
    );
  }
}

BannersContainer.defaultProps = {
  className: "",
};

BannersContainer.propTypes = {
  className: PropTypes.string,
};

export default BannersContainer;
